import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { InsightsLibraryEffects, InsightsLibraryReducer } from './state/insights-library';

@NgModule({
  imports: [
    StoreModule.forFeature('insights-library', InsightsLibraryReducer.reducer),
    StoreModule.forFeature('insights-library/dashboard-item-selector', InsightsLibraryReducer.dashboardItemSelectorReducer),
    StoreModule.forFeature('insights-library/visual-item-selector', InsightsLibraryReducer.visualItemSelectorReducer),
    EffectsModule.forFeature([InsightsLibraryEffects]),
  ]
})
export class InsightsLibraryStateModule { }
